import React, { useContext, useMemo } from 'react'
import { LotacaoAgendaModel } from 'view/agenda/model-agenda'

import { AgendaContextModel } from './model-agendaContext'

const DEFAULT_VALUES: AgendaContextModel = {
  isAD: false,
  lotacao: null,
  refetchInfos: () => {},
}

export const AgendaContext = React.createContext<AgendaContextModel>(DEFAULT_VALUES)

interface AgendaProviderProps {
  isAD: boolean
  lotacao: LotacaoAgendaModel
  refetchInfos(): void
  children: React.ReactNode
}

export function AgendaProvider(props: Readonly<AgendaProviderProps>) {
  const { children, isAD, lotacao, refetchInfos } = props

  const value = useMemo(() => ({ isAD, lotacao, refetchInfos }), [isAD, lotacao, refetchInfos])

  return <AgendaContext.Provider value={value}>{children}</AgendaContext.Provider>
}

export const useAgendaContext = () => useContext(AgendaContext)
